import { getMobileOS } from '@beef/utils';
export var isAndroid = getMobileOS() === 'android';
export var isIOS = getMobileOS() === 'ios';